import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { APP_ROUTES } from './consts';
import { Loading } from '@components/common';

// Lazy load pages for code splitting
const Home = lazy(() => import('@pages/Home'));
const Login = lazy(() => import('@pages/Login'));
const NewBlog = lazy(() => import('@pages/NewBlog'));
const Blog = lazy(() => import('@pages/Blog'));
const Profile = lazy(() => import('@pages/Profile'));

// Loading fallback
function PageLoader() {
    return (
        <div className="min-h-screen bg-dark flex items-center justify-center">
            <Loading size="lg" />
        </div>
    );
}

export default function Router() {
    return (
        <BrowserRouter>
            <Suspense fallback={<PageLoader />}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path={`/${APP_ROUTES.HOME}`} element={<Home />} />
                    <Route path={`/${APP_ROUTES.LOGIN}`} element={<Login />} />
                    <Route path={`/${APP_ROUTES.BLOGGING}`} element={<NewBlog />} />
                    <Route path={`/${APP_ROUTES.BLOG_DETAILS}`} element={<Blog />} />
                    <Route path={`/${APP_ROUTES.PROFILE}`} element={<Profile />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
}
